import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

export function BottomSheet({ open, onOpenChange, title, description, children, testId }: {
  open: boolean; onOpenChange: (o: boolean) => void; title: React.ReactNode; description?: React.ReactNode; children: React.ReactNode; testId: string;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" data-testid={testId} className="max-h-[92vh] overflow-y-auto rounded-t-3xl px-5 pb-8 max-w-md mx-auto">
        <div className="mx-auto mb-3 h-1.5 w-12 rounded-full bg-slate-200" />
        <SheetHeader className="text-left mb-4">
          <SheetTitle className="text-xl font-bold">{title}</SheetTitle>
          {description ? <SheetDescription>{description}</SheetDescription> : <SheetDescription className="sr-only">sheet</SheetDescription>}
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
}
